import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import georedirect_45global from "/opt/buildhome/repo/middleware/georedirect.global.js";
import locale_45global from "/opt/buildhome/repo/middleware/locale.global.ts";
import redirect_45trailing_45slash_45global from "/opt/buildhome/repo/middleware/redirect-trailing-slash.global.js";
import redirect_45global from "/opt/buildhome/repo/middleware/redirect.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  georedirect_45global,
  locale_45global,
  redirect_45trailing_45slash_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sanctum:auth": () => import("/opt/buildhome/repo/modules/m/nuxt-auth-sanctum-main/runtime/middleware/sanctum.auth.ts")
}